var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResource = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L800 0L800 800L0 800L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resource"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L800 0L800 800L0 800L0 0Z",
    id: "T\\u0142o",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.403 771.156L355.256 767.994L185.781 528.963L208.211 448.723L263.311 463.38L326.038 529.056L298.745 435.503L335.989 380.256L269.195 217.703L336.641 93.5625L449.819 128.669L522.1 254.388L476.047 262.2L415.925 207.486L451.188 282.586L450.138 340.967L409.372 369.442L463.981 371.448L537.645 408.691L582.567 365.138L642.705 394.914L659.341 453.63L629.7 432.092L507.566 494.541L437.28 470.494L446.436 428.067L379.614 433.183L416.447 451.797L401.619 487.645L492.302 536.528L524.083 660.626L499.942 714.892L545.875 683.08L650.297 668.333L538.406 771.161L538.403 771.156ZM290.709 765.628L207.147 762.041L250.37 662.031L304.089 739.68L290.709 765.628L290.709 765.628ZM155.116 707.753L137.803 653.261L82.3297 637.317L136.795 619.989L152.752 564.52L170.08 618.981L225.552 634.95L171.088 652.266L155.119 707.75L155.116 707.753ZM550.402 655.866L516.706 524.259L629.272 463.338L713.152 556.028L683.988 637.638L550.402 655.866L550.402 655.866ZM264.797 438.558L172.402 414.164L140.686 306.102L243.911 247.586L301.63 379.033L264.797 438.559L264.797 438.558ZM533.712 377.664L473.736 346.945L476.195 286.227L544.331 270.731L586.133 332.131L533.716 377.663L533.712 377.664ZM625.658 303.867L603.417 232.891L531.323 211.859L602.277 189.575L623.308 117.494L645.577 188.447L717.67 209.506L646.717 231.748L625.659 303.867L625.658 303.867ZM510.953 195.156L466.162 106.466L420.894 94.0281L456.277 28.8438L502.077 51.1531L529.952 144.188L510.952 195.156L510.953 195.156Z",
    id: "Kszta\\u0142t",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResource);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/resource.f567ffe6525353e79850307976fe3bb3.svg";